








import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import SharingButtons from "@tool/Components/SharingButtons.vue";

import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    components: {
        ThemeBlock,
        SharingButtons
    },
})
